import { graphql } from 'react-relay';

const classificationMutation = graphql`
  mutation classificationMutation(
    $input: PackageTrackerAddressClassificationMutationInput!
  ) {
    packageTrackerAddressClassification(input: $input) {
      success
      errors {
        message
      }
    }
  }
`;

export default classificationMutation;
